import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
class Tabbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.currentPage,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentPage !== this.props.currentPage) {
      this.setState({ currentPage: this.props.currentPage });
    }
  }

  handler = (item) => {
    if (this.props.setContract) this.props.setContract(item);
    this.setState({ currentPage: item.text });
  };

  render() {
    const list = this.props.list ? this.props.list : new Array(4).fill({});
    return (
      <div className={this.props.classes}>
        <div className='relative border-b border-gray-300'>
          <nav className='-mb-px flex w-full justify-start overflow-x-auto' aria-label='Tabs'>
            {list.map((item, index) => {
              const isActive = this.state.currentPage === item.text;
              return (
                <span
                  key={item.text || index}
                  onClick={() => this.handler(item)}
                  id={item.text}
                  className={`border-b-2 px-5 text-center text-ts-sm transition-colors duration-200 cursor-pointer whitespace-nowrap ${this.props.titleClasses ? this.props.titleClasses : 'py-3'} ${
                    isActive
                      ? 'border-ds-brand text-ds-brand font-semibold'
                      : 'border-transparent text-gray-600 font-medium hover:text-gray-900'
                  }`}
                >
                  {item.text || <Skeleton width={100} height={25} />}
                </span>
              );
            })}
          </nav>
        </div>
      </div>
    );
  }
}

Tabbar.defaultProps = {
  classes: '',
};

export default Tabbar;
